import { useQuery } from '@tanstack/react-query';

import { listPackages } from './services';

export const usePackagesQuery = ({ type }) =>
  useQuery({
    queryKey: ['managemobi', 'packages', 'list', { type }],
    queryFn: () => listPackages(type),
    select: ({ data }) => data.filter(pkg => !pkg.isArchived),
  });
